var base = require('navbar/navbar');
import {Amplify, Auth } from "aws-amplify";

Vue.component('spark-navbar', {
    mixins  : [base],

    data() {
        return {
            unreadMessengerCount: 0
        }
    },

    created() {
        this.checkNewMessages();

        Bus.$on('messengerNotifications', () => this.checkNewMessages());

        const teamId = this.$root.currentTeam.id;
        window.Echo.private(`App.Team.${teamId}`)
            .listen('.sms.received', (messageData) => {
                if(this.isUnread(messageData.sms.contact, this.$root.user.id)) {
                    this.unreadMessengerCount++;
                }
            });
    },

    methods : {
        openInviteModal() {
            Bus.$emit('openInviteModal');
        },

        async checkNewMessages() {
            await this.$http.get(this.$laroute.route('api.chat.checkNewMessages'))
                .then(({ data }) => this.unreadMessengerCount = data['assignedCount']);
        },

        isUnread(contact, userId) {
            return !contact.assigned_users || contact.assigned_users.length == 0 || contact.assigned_users.includes(userId);
        },

        async stopImpersonating() {

            const propsContainer = document.getElementById("stopImpBtn");
            const propData = Object.assign({}, propsContainer.dataset);

            Amplify.configure({
                aws_project_region: propData.region,
                aws_cognito_region: propData.region,
                aws_user_pools_id: propData.pool,
                aws_user_pools_web_client_id: propData.client,
                authenticationFlowType: "CUSTOM_AUTH",

            });

            const imp = localStorage.getItem('impersonators');

            let impersonators = imp ? JSON.parse(imp) : [];

            if (impersonators.length > 0) {

                const impersonator = impersonators.shift()

                localStorage.setItem('CognitoIdentityServiceProvider.' + propData.client + '.LastAuthUser', impersonator);
                localStorage.setItem('impersonators', JSON.stringify(impersonators));

                await Auth.currentAuthenticatedUser({
                    bypassCache: true,
                });

            }

            window.location.href = '/spark/kiosk/users/stop-impersonating';
        }
    }
});
